"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnidentifiedDirectHubClient = void 0;
const DirectHubClient_1 = require("./DirectHubClient");
class UnidentifiedDirectHubClient extends DirectHubClient_1.DirectHubClient {
    constructor(data) {
        super(data);
        this.data = data;
        this.identifiedClient = null;
        this.stale = false;
    }
    updateData(data) {
        let result = super.updateData(data);
        if (this.identifiedClient) {
            result = this.identifiedClient.updateData(data);
        }
        return result;
    }
    signal(type) {
        super.signal(type);
        if (this.identifiedClient) {
            this.identifiedClient.signal(type);
        }
    }
}
exports.UnidentifiedDirectHubClient = UnidentifiedDirectHubClient;
//# sourceMappingURL=UnidentifiedDirectHubClient.js.map